<template>
  <el-tabs v-model="activeName"
           type="card">
    <el-tab-pane label="绑定客户"
                 name="second">
      <el-table :data="grpParkList"
                border
                style="width: 100%;"
                :height="childTableHeight"
                :header-cell-style="{padding:'0px',height:'35px'}"
                :cell-style="{padding:'0px',height:'35px'}">
        <el-table-column type="index"
                         label="序号"
                         width="50">
        </el-table-column>
        <el-table-column prop="unionName"
                         label="绑定客户">
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="用户权限"
                 name="first">
      <el-table :data="grpInfoList"
                border
                style="width: 100%;"
                :height="childTableHeight"
                :header-cell-style="{padding:'0px',height:'35px'}"
                :cell-style="{padding:'0px',height:'35px'}">
        <el-table-column prop="fGrpName"
                         width="200"
                         label="分组名称">
        </el-table-column>
        <el-table-column prop="fIsAdmin"
                         width="100"
                         label="组类型">
        </el-table-column>
        <el-table-column prop="fModName"
                         width="100"
                         label="模块名称">
        </el-table-column>
        <el-table-column prop="fPersName"
                         width="100"
                         label="权限名称">
        </el-table-column>
        <el-table-column prop="fFunName"
                         label="功能按钮描述">
        </el-table-column>
      </el-table>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: 'groupPerAndPark',
  data () {
    return {
      form: {
      },
      activeName: 'second'
    }
  },
  props: {
    childTableHeight: Number,
    grpInfoList: Array,
    grpParkList: Array
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/groupPerAndPark.vue